// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"87e9331a","126":"c2cba9a8","608":"7b202665","787":"b5ba76df"}[chunkId] + ".chunk.js";
};